import { SurveyMetadataForm } from '@ps/survey-utils';

export function isEligibleForStandardSurvey(
  metadata: SurveyMetadataForm,
): boolean {
  return (
    metadata.selectedCountries.length === 1 &&
    metadata.selectedLanguages.length === 1
  );
}
